import { Navigate, Route, Routes } from "react-router-dom";

import { authStorage } from "./lib/auth";
import AdminPage from "./pages/Admin/AdminPage";
import CasosPage from "./pages/Casos/CasosPage";
import ConsultarCasosPage from "./pages/Consultar/ConsultarCasosPage";
import EnviarCasosPage from "./pages/Enviar/EnviarCasosPage";
import LoginPage from "./pages/Login/LoginPage";

function RequireAuth({ children }: { children: React.ReactNode }) {
  if (!authStorage.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

function Stub({ title }: { title: string }) {
  return (
    <div style={{ padding: 32 }}>
      <h1>{title}</h1>
      <p>Página por implementar.</p>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/casos"
        element={
          <RequireAuth>
            <CasosPage />
          </RequireAuth>
        }
      />
      <Route
        path="/consultar"
        element={
          <RequireAuth>
            <ConsultarCasosPage />
          </RequireAuth>
        }
      />
      <Route
        path="/enviar"
        element={
          <RequireAuth>
            <EnviarCasosPage />
          </RequireAuth>
        }
      />
      <Route
        path="/dashboard"
        element={<RequireAuth><Stub title="Dashboard" /></RequireAuth>}
      />
      <Route
        path="/utilizadores"
        element={<RequireAuth><AdminPage /></RequireAuth>}
      />
      <Route path="*" element={<Navigate to="/casos" replace />} />
    </Routes>
  );
}
